import React, { useSyncExternalStore } from "react";
import { getAlarmSnapshot, subscribeAlarms } from "../../Utils/alarmControl";
import "./alarmstatusbar.css";

export const CONNECTION_LOST_TEXT =
  "Connection lost. Alerts are not reaching this station.";

const hiddenCriticalText = (count) =>
  count === 1
    ? "1 Wellness Check Required is waiting. Pop-up alerts are off."
    : `${count} Wellness Checks Required are waiting. Pop-up alerts are off.`;

function AlarmStatusBar({ hiddenCriticalCount = 0 }) {
  const alarms = useSyncExternalStore(subscribeAlarms, getAlarmSnapshot);

  const rows = [];
  if (alarms.connection.lost) {
    rows.push({ key: "connection", text: CONNECTION_LOST_TEXT });
  }
  if (hiddenCriticalCount > 0) {
    rows.push({ key: "hidden", text: hiddenCriticalText(hiddenCriticalCount) });
  }

  if (!rows.length) return null;

  return (
    <section aria-label="Alarm status" className="alarm-status-bar">
      <ul className="alarm-status-bar-rows">
        {rows.map((row) => (
          <li key={row.key}>{row.text}</li>
        ))}
      </ul>
    </section>
  );
}

export default AlarmStatusBar;
